import MainTeamDetail from "../components/team-detail/main-detail";

function TeamManagmentDetail() {
  return (
    <div className="">
      <MainTeamDetail />
    </div>
  );
}

export default TeamManagmentDetail;
